import { useKrakenMutation } from '@/components/GraphQLClient';
import { useAuth } from '@/components/Providers/Auth';
import { useScopedTokenContext } from '@/context';

import CreateCustomerFeedback from './CreateCustomerFeedback.graphql';

export const useCreateCustomerFeedback = () => {
  const { accessToken } = useAuth();
  const { scopedToken } = useScopedTokenContext();

  const authToken = scopedToken || accessToken;

  return useKrakenMutation({
    mutation: (_: any) => CreateCustomerFeedback,
    validateFn(response) {
      return Promise.resolve(response);
    },
    ...(authToken && {
      requestHeaders: {
        Authorization: authToken,
      },
    }),
    gcTime: 0,
  });
};
